import { createReducer } from 'redux-create-reducer'
import * as SearchActions from '../actions/search-actions';

const initialState = {
    results: [],
    previousQueries: [],
    isLoading: false,
    error: null
}

const searchReducer = createReducer(initialState, {
    [SearchActions.SEARCH_LOADING]: (state) => ({
        ...state, error: null, isLoading: true
    }),
    [SearchActions.SEARCH_RESULT]: (state, { payload: { results } })=> ({
        ...state,
        error: null,
        isLoading: false,
        results: [
            ...results.filter((item) => item['type'] === 'vector'),
            ...results.filter((item) => item['type'] === 'index')
        ]
    }),
    [SearchActions.SEARCH_ERROR]: (state, { payload: { error } }) => ({
        ...state, error , isLoading: false
    }),
    [SearchActions.SET_PREVIOUS_QUERIES]: (state, { payload: { previous } })=> ({
        ...state, previousQueries: previous
    })
});

export default searchReducer
